import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-xs font-semibold text-neutral-600 mb-3"
}
const _hoisted_2 = { class: "flex flex-col space-y-2" }

import { ref } from "vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimeRadio',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);

const date_time_options = [
    { id: '1', label: 'Date Only', value: 'date_only', radioSelected: null},
    { id: '2', label: 'Date & Time', value: 'date_time', radioSelected: null},
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioGroup, {
        options: date_time_options,
        name: "data"
      })
    ])
  ]))
}
}

})